import { useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Control, Controller as RHFController } from 'react-hook-form';

import { AddCommentsDialog } from './AddCommentsDialog';

type Props = {
  control: Control<any>;
  Controller: typeof RHFController;
  setValue: (name: any, value: any) => void;
  getValues: () => any;
  openWithCommentType?: string;
  onDialogOpened?: () => void;
};

export const CommentsSection = ({
  control,
  Controller,
  setValue,
  getValues,
  openWithCommentType,
  onDialogOpened,
}: Props) => {
  const [showAddComments, setShowAddComments] = useState(false);

  const handleOpenDialog = () => {
    setShowAddComments(true);
  };

  const handleCloseDialog = () => {
    setShowAddComments(false);
    onDialogOpened?.();
  };

  const shouldShowDialog = showAddComments || Boolean(openWithCommentType);

  return (
    <div className="aspiration-search-form__section">
      <div className="aspiration-comment">
        <label htmlFor="comments">Comments:</label>
        <div className="aspiration-inputgroup p-inputgroup">
          <Controller
            name="comments"
            control={control}
            render={({ field }) => (
              <InputTextarea
                id="aspiration-comment"
                {...field}
                value={field.value || ''}
              />
            )}
          />
          <Button
            icon="pi pi-plus"
            type="button"
            onClick={handleOpenDialog}
            className="add-comments"
          />
        </div>
      </div>

      <div className="aspiration-comment">
        <label htmlFor="donorCondition">Donor Condition:</label>
        <Controller
          name="donorCondition"
          control={control}
          render={({ field }) => (
            <InputTextarea
              id="aspiration-comment"
              {...field}
              value={field.value || ''}
            />
          )}
        />
      </div>

      {shouldShowDialog && (
        <Dialog
          header="Add Comments"
          visible={shouldShowDialog}
          onHide={handleCloseDialog}
          className="aspiration__add-comments-dialog"
        >
          <AddCommentsDialog
            key={openWithCommentType || 'default'}
            setShowAddComments={setShowAddComments}
            setValue={setValue}
            getValues={getValues}
            initialSelectedCommentType={openWithCommentType}
            onClose={handleCloseDialog}
          />
        </Dialog>
      )}
    </div>
  );
};
